import React from 'react';
import T from 'prop-types';
// icons
import { ReactComponent as CheckIcon } from 'icons/check.svg';
import { ReactComponent as DashIcon } from 'icons/dash.svg';
// styles
import classnames from 'classnames/bind';
import styles from './Indicator.module.scss';

const cx = classnames.bind(styles);

const Indicator = ({ checked }) => {
  const Icon = checked ? CheckIcon : DashIcon;

  return <div className={cx('wrapper', { checked, unchecked: !checked })}>{<Icon />}</div>;
};

Indicator.propTypes = {
  checked: T.bool.isRequired,
};

export default Indicator;
